module.exports = __webpack_public_path__ + "img/logo.f36be509.svg";